<script>
    import {External} from "../../external";

    export let data, filter, change, useLabelForValue, storeSelectedInFilterId;

    $: if (!filter.func) filter.func = 'is';
    $: if (!filter.value) {
        filter.value = '';
        change();
    }

    function onChange(e) {
        if (storeSelectedInFilterId)
            filter.id = External.WebPlatform.parse(filter.value);

        let selected = External.$(e.target).find('option:selected');
        filter.value = useLabelForValue ? selected.text().trim() : selected.attr('value');

        change(e);
    }
</script>
{#each data as item (item)}
    <div class="col20 f-left func-option" class:active={item.func === filter.func} data-role="{item.func}">
        <label>
            <input type="radio" on:change={change} name="option" value="{item.func}" bind:group={filter.func}/>
            <span>{item.name}</span>
        </label>
      {#if item.func === filter.func}
          <div class="col20 f-left option-value">
              <select name="value" bind:value={filter.value} on:change={e => onChange(e)}>
                {#each item.options as option (option)}
                    <option value="{option.value}">{option.label}</option>
                {/each}
              </select>
          </div>
      {/if}
    </div>
{/each}